<div
  class="page-container"
  [ngStyle]="{
    '--color50': seminarCategory?.color50 ?? seminar.category1?.color50,
    '--color0': seminarCategory?.color0 ?? seminar.category1?.color0,
    '--color70': seminarCategory?.color70 ?? seminar.category1?.color70,
    '--color80': seminarCategory?.color80 ?? seminar.category1?.color80,
    '--color90': seminarCategory?.color90 ?? seminar.category1?.color90,
  }">
  <div class="course-title background-transparent justify-space-between">
    <span class="font-bold-display-medium">
      {{ seminar.title }}
    </span>
  </div>
  <div class="course-container">
    <div class="general-wrapper">
      <div class="general-information">
        <div
          class="flex-r justify-space-between align-self-stretch align-center gap-4">
          <span class="font-medium-headline-large">
            Allgemeine Informationen
          </span>
          <div class="inwi-chip-text-green-outline">
            {{ seminar.maxParticipants ?? '00' }} frei
          </div>
        </div>
        <div class="flex-c">
          <span class="font-medium-title-large font-color-black">
            Empfehlenswert für:
          </span>
          <span class="font-regular-body-large font-color-black pre-line">
            {{ seminar.recommendation }}
          </span>
        </div>
        <div class="flex-c">
          <span class="font-medium-title-large font-color-black">
            Voraussetzung:
          </span>
          <span class="font-regular-body-large font-color-black pre-line">
            {{
              !seminar.requirement || seminar.requirement === ''
                ? 'Keine'
                : seminar.requirement
            }}
          </span>
        </div>
        <div class="flex-c font-color-black">
          <span class="font-medium-title-large"> Ort: </span>
          @if (seminar.modality === 'online') {
            <div class="flex-c gap-16">
              <div class="flex-r align-center gap-16">
                <span>Online</span>
                <i class="fa-regular fa-globe font-color-black fa-xl"></i>
              </div>
              <div class="flex-c gap-8">
                <span>Link zum Meeting:</span>
                <a
                  class="course-link"
                  href="{{ seminar.link }}"
                  target="_blank">
                  Hier geht's zum Seminar-Raum
                </a>
              </div>
            </div>
          } @else {
            <div class="flex-r align-center gap-16 align-self-stretch">
              <div class="flex-c font-color-black">
                <span class="font-bold-body-large">
                  {{ seminar.address?.title }}
                </span>
                <span class="font-regular-body-large">
                  {{ seminar.address?.street }}
                  {{ seminar.address?.houseNumber }}
                </span>
                <span class="font-regular-body-large">
                  {{ seminar.address?.zip }}
                  {{ seminar.address?.city }}
                </span>
              </div>
              <div class="icon-24">
                <i
                  class="fa-regular fa-location-dot font-color-black fa-xl"></i>
              </div>
            </div>
          }
        </div>
        <div class="flex-c">
          <span class="font-medium-title-large font-color-black">
            Fachbereich:
          </span>
          <span class="font-regular-body-large font-color-black">
            {{ seminar.category1?.name }}{{ seminar.category2 ? ', ' : '' }}
            {{ seminar.category2?.name }}
          </span>
        </div>
      </div>
      <div class="lecturer-information">
        @if (seminar.lecturer1 != null) {
          <div class="flex-r align-center justify-center gap-12">
            <div
              class="lecturer-avatar"
              [class.avatar-small]="seminar.lecturer2 != null">
              <app-avatar
                placeholderBackgroundColor="#EEF3EB"
                [placeholderColor]="
                  seminarCategory?.color0 ?? seminar.category1.color0
                "
                [user]="seminar.lecturer1"></app-avatar>
            </div>
            <div class="lecturer-informations">
              <span class="font-medium-headline-small">
                {{ getUserFullName(seminar.lecturer1) }}
              </span>
              <span class="font-regular-body-large font-color-black">
                {{ seminar.lecturer1?.jobTitle ?? 'Beruf' }}
              </span>
              <span class="font-regular-body-large font-color-black">
                {{ seminar.lecturer1?.description1 ?? 'Beschreibung 1' }}
              </span>
              <span class="font-regular-body-large font-color-black">
                {{ seminar.lecturer1?.description2 ?? 'Beschreibung 2' }}
              </span>
              <span class="font-regular-body-large font-color-black">
                {{ seminar.lecturer1?.description3 ?? 'Beschreibung 3' }}
              </span>
            </div>
          </div>
          <button
            type="button"
            class="inwi-icon-text-button-medium-outline border-none align-self-stretch">
            <div class="button-content">
              <div class="button-icon">
                <i class="fa-regular fa-sparkle"></i>
              </div>
              <div class="button-text">Zur Vollständigen Vita</div>
            </div>
          </button>
        }
        @if (seminar.lecturer2 != null) {
          <div class="lecturer-divider"></div>
          <div class="flex-r align-center justify-center gap-12">
            <div class="lecturer-avatar avatar-small">
              <app-avatar
                placeholderBackgroundColor="#EEF3EB"
                [placeholderColor]="
                  seminarCategory?.color0 ?? seminar.category1.color0
                "
                [user]="seminar.lecturer2"></app-avatar>
            </div>
            <div class="lecturer-informations">
              <span class="font-medium-headline-small">
                {{ getUserFullName(seminar.lecturer2) }}
              </span>
              <span class="font-regular-body-large font-color-black">
                {{ seminar.lecturer2.jobTitle ?? 'Beruf' }}
              </span>
              <span class="font-regular-body-large font-color-black">
                {{ seminar.lecturer2.description1 ?? 'Beschreibung 1' }}
              </span>
              <span class="font-regular-body-large font-color-black">
                {{ seminar.lecturer2.description2 ?? 'Beschreibung 2' }}
              </span>
              <span class="font-regular-body-large font-color-black">
                {{ seminar.lecturer2.description3 ?? 'Beschreibung 3' }}
              </span>
            </div>
          </div>
          <button
            type="button"
            class="inwi-icon-text-button-medium-outline border-none align-self-stretch">
            <div class="button-content">
              <div class="button-icon">
                <i class="fa-regular fa-sparkle"></i>
              </div>
              <div class="button-text">Zur Vollständigen Vita</div>
            </div>
          </button>
        }
      </div>
    </div>
    @if (sponsorCards && sponsorCards.length > 0) {
      <app-sponsor-card [sponsorCards]="sponsorCards"></app-sponsor-card>
    }
    <div class="course-content-information">
      <span class="font-medium-headline-large"> Kursinhalte </span>
      <div class="flex-c">
        <span class="font-medium-title-large font-color-black">
          Beschreibung:
        </span>
        <span class="font-regular-body-large font-color-black pre-line">
          {{ seminar.description }}
        </span>
      </div>

      <div class="flex-c">
        <span class="font-medium-title-large font-color-black">
          Worum geht es
        </span>
        <span class="font-regular-body-large font-color-black pre-line">
          {{ seminar.about }}
        </span>
      </div>

      <div class="flex-c">
        <span class="font-medium-title-large font-color-black"> Ziele: </span>
        <span class="font-regular-body-large font-color-black pre-line">
          {{ seminar.goals }}
        </span>
      </div>

      <div class="flex-c">
        <span class="font-medium-title-large font-color-black">
          Nutzen für die Praxis:
        </span>
        <span class="font-regular-body-large font-color-black pre-line">
          {{ seminar.benefit }}
        </span>
      </div>
    </div>
    <div class="facts-information">
      <span class="font-medium-headline-large"> Fakten </span>
      <div class="display-flex align-start align-self-stretch gap-58">
        <div class="flex-c gap-16 align-start flex-1-1-0">
          <div class="flex-c align-self-stretch">
            <span class="font-medium-title-large font-color-black">
              Seminarnummer:
            </span>
            <span class="font-regular-body-large font-color-black">
              {{ seminar.seminarNr }}
            </span>
          </div>

          <div class="flex-c align-self-stretch">
            <span class="font-medium-title-large font-color-black">
              Konditionen:
            </span>
            <div
              class="display-flex align-start gap-16 align-self-stretch padding-bottom-16">
              <div class="conditions-container">
                @for (condition of seminar.conditions; track $index) {
                  <span
                    class="condition-label font-regular-body-large font-color-black">
                    {{
                      condition.type === 'vdp'
                        ? 'VDP Mitglied'
                        : condition.type === 'vdb'
                          ? 'VDB Mitglied'
                        : condition.type === 'early'
                          ? 'Frühbucher'
                          : condition.type === 'bed'
                            ? 'BED Mitglied'
                            : condition.type === 'office'
                              ? 'Praxis (ab 3 Personen)'
                              : condition.type === 'logo'
                                ? 'LOGO Deutschland Mitglied'
                                : 'Regulär'
                    }}{{
                      condition.date
                        ? ' (bei Buchung bis ' +
                          (condition.date | date: 'dd.MM.yyyy') +
                          ')'
                        : ''
                    }}
                  </span>
                  <span
                    class="condition-value font-bold-body-large font-color-black">
                    {{ condition.price | currency: 'EUR' }}
                  </span>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="flex-c gap-16 align-start flex-1-1-0">
          @if (seminar.fobiPoints) {
            <div class="flex-c align-self-stretch">
              <span class="font-medium-title-large font-color-black">
                Fobipunkte:
              </span>
              <span class="font-regular-body-large font-color-black">
                {{ getSeminarFobiPoints(seminar) }} FP ({{
                  getSeminarFobiPoints(seminar)
                }}
                UE)
              </span>
            </div>
          }
          <div class="flex-c align-self-stretch">
            <span class="font-medium-title-large font-color-black">
              Datum und Uhrzeit:
            </span>
            <div class="flex-c gap-4">
              @for (dateSeries of seminar.dateSeries; track $index) {
                <div class="flex-c align-start gap-4">
                  <div class="flex-c">
                    <span class="font-medium-body-large font-color-black">
                      {{ dateSeries.name }}
                    </span>
                    @for (date of dateSeries.dates; track $index) {
                      <span class="font-regular-body-large font-color-black">
                        {{ date.startDate | date: 'EEE, dd.MM.yyyy HH:mm' }} -
                        {{ date.endDate | date: 'HH:mm' }} Uhr
                      </span>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="flex-c align-self-stretch">
        <span class="font-medium-title-medium font-color-black">
          {{ seminar.additionsTitle }}
        </span>
        <span class="font-regular-body-medium font-color-black pre-line">
          {{ seminar.additionsDescription }}
        </span>
      </div>
    </div>
    <app-file-manager
      [seminarId]="seminar.id"
      [seminarCategory]="seminar.category1"
      [listView]="true"
      [isAdminView]="false"
      [allowUpload]="false"
      [allowDelete]="false"></app-file-manager>
  </div>
</div>
